<template>
	<v-menu offset-y>
		<template v-slot:activator="{ on, attrs }">
			<v-btn
				outlined
				x-small
				color="#2D4B95"
				:loading="loading"
				v-bind="attrs"
				v-on="on"
			>
				<v-icon small>mdi-sort</v-icon>
				<div class="d-flex align-center ml-1" style="gap: 5px;">
					<p class="mb-0">Ordenar Por: <b>{{ getCurrentSortingLabel() }}</b></p>
					<v-icon x-small>{{getCurrentSortingIcon()}}</v-icon>
				</div>
			</v-btn>
		</template>
		<v-list dense>
			<v-list-item
				v-for="option in sortingOptions"
				:key="option.value"
				@click="onSortOptionSelected(option)"
				:class="{ 'v-list-item--active': currentSortingValue === option.value }"
			>
				<v-list-item-title class="caption">
					<div class="d-flex align-center justify-space-between" style="gap: 4px;">
						<div class="d-flex align-center" style="gap: 4px;">
							<v-icon small>{{option.icon}}</v-icon>
							<p class="mb-0">{{ option.label }}</p>
						</div>
						<v-icon v-if="currentSortingValue === option.value" small color="#2D4B95" class="ml-2">mdi-check</v-icon>
					</div>
				</v-list-item-title>
			</v-list-item>
		</v-list>
	</v-menu>
</template>

<script>
export default {
	name: 'TableSortBy',
	props: {
		loading: {
			type: Boolean,
			default: false
		},
		sortingOptions: {
			type: Array,
			default: () => []
			// Ejemplo de formato: [{ label: 'Nombre', value: 'name' }, { label: 'Fecha', value: 'date' }]
		},
		currentSortingValue: {
			type: [String, Number],
			default: ''
		}
	},
	methods: {
		getCurrentSortingLabel() {
			const currentOption = this.sortingOptions.find(option => option.value === this.currentSortingValue)
			return currentOption ? currentOption.label : 'Seleccionar'
		},
		getCurrentSortingIcon() {
			const currentOption = this.sortingOptions.find(option => option.value === this.currentSortingValue)
			return currentOption ? currentOption.icon : 'mdi-menu-swap'
		},
		onSortOptionSelected(option) {
			this.$emit('sort-changed', option.value)
		}
	}
}
</script>

<style>

</style>